<template>
  <section class="bg-white py-20 sm:py-28">
    <div class="container mx-auto flex flex-col items-center px-4 text-center">

      <h2 class="text-4xl lg:text-5xl font-extrabold tracking-tight text-gray-900">
        Pronto para transformar<br />sua operação de delivery?
      </h2>

      <p class="mt-4 max-w-2xl text-lg text-gray-700">
        Seja nosso parceiro e descubra como a Overx pode caminhar com você — do pedido à entrega.
      </p>

      <button class="mt-10 inline-flex items-center gap-x-4 rounded-full bg-orange-500 px-8 py-4 text-lg font-bold text-white shadow-lg shadow-orange-500/30 transition-all duration-300 hover:bg-orange-600 hover:scale-105 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2">
        <span>Quero ser parceiro da OverX</span>
        
        <span class="flex h-7 w-7 flex-col items-center justify-center rounded-full bg-orange-600">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="3" stroke="currentColor" class="h-3 w-3">
            <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 15.75 7.5-7.5 7.5 7.5" />
          </svg>
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="3" stroke="currentColor" class="h-3 w-3">
            <path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
          </svg>
        </span>
      </button>

    </div>
  </section>
</template>

<script>
export default {
  name: 'CtaSection',
}
</script>
